export const waDigits = (number) => {
  let d = String(number || "").replace(/\D/g, "");
  if (d.length === 10) d = "91" + d;
  return d;
};

export const waLink = (number, message) => {
  const d = waDigits(number);
  if (!d) return "";
  return `https://wa.me/${d}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
};

export const openWhatsApp = (number, message) => {
  const url = waLink(number, message);
  if (url) window.open(url, "_blank", "noopener,noreferrer");
  return url;
};
